import { LookupConstants } from 'constants/lookupConstants';
import { createAction } from 'redux-actions';

export const getLoanPurposesAction = createAction(LookupConstants.GET_LOAN_PURPOSES);
